import { render, staticRenderFns } from "./drawerContacts.vue?vue&type=template&id=e10ef802&"
import script from "./drawerContacts.vue?vue&type=script&lang=js&"
export * from "./drawerContacts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports